/* Start the main landing-page cart with the same sample basket as the hero.
 * Seed only the first empty basket per tab session, then preserve visitors' edits.
 * The installed cart keeps ownership of opening, offers and checkout behavior.
 */
(() => {
  'use strict';
  const script = document.querySelector('script[data-cv-landing-demo]');
  if (!script) return;
  const root = script.dataset.root || '/';
  const sessionKey = 'cv-landing-demo-started-v1';
  const handles = ['abandoned-cart-planter', 'before-you-go-cap'];
  let started = false;
  let opening = false;
  let replaying = false;
  const hasStarted = () => {
    try { return started || sessionStorage.getItem(sessionKey) === 'true'; }
    catch { return started; }
  };
  const markStarted = () => {
    started = true;
    try { sessionStorage.setItem(sessionKey, 'true'); } catch {}
  };
  const json = async (url, options) => {
    const response = await fetch(url, options);
    if (!response.ok) throw new Error('Demo basket could not be prepared');
    return response.json();
  };
  const prepare = async () => {
    if (hasStarted()) return;
    const cart = await json(root + 'cart.js');
    if (cart.item_count > 0) { markStarted(); return; }
    const catalog = await json(script.dataset.productsSrc);
    const items = handles.map(handle => {
      const product = catalog.products.find(product => product.handle === handle);
      const variant = product?.variants.find(variant => variant.available !== false);
      return variant ? { id: variant.id, quantity: 1 } : null;
    }).filter(Boolean);
    if (items.length !== handles.length) throw new Error('Demo products are unavailable');
    await json(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items })
    });
    markStarted();
  };
  window.addEventListener('click', async event => {
    if (replaying || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = event.target instanceof Element
      ? event.target.closest('#cart-icon-bubble, [data-cv-floating-cart]') : null;
    if (!target || hasStarted()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (opening) return;
    opening = true;
    target.setAttribute('aria-busy', 'true');
    try {
      // Re-check the shared Shopify basket inside the lock, so simultaneous
      // first opens in two tabs cannot add duplicate samples.
      if (navigator.locks?.request) await navigator.locks.request('cv-landing-demo-seed', prepare);
      else await prepare();
    } catch {
      // If Shopify is unavailable, the original cart trigger still works and
      // the next open may retry. Never retry an uncertain POST in this flow.
    } finally {
      opening = false;
      target.removeAttribute('aria-busy');
      replaying = true;
      try { target.click(); } finally { replaying = false; }
    }
  }, true);
})();
